export { default as OnSite } from "./main";
export type * as _OnSite from "./_model";
import routes from "./routes";
import * as Anchors from "./anchors";
export default {
  routes,
  Anchors,
};
